import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { Heading } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { useCheckoutSizes } from '../../utils/responsive'
import { useHasZeroAprConsumerLendingPromotion, useIsAfterpayFinanceFeeEligible } from '../../state'

export const ConsumerLendingTagline: FunctionComponent = () => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const hasZeroAprPromotion = useHasZeroAprConsumerLendingPromotion()
  const isAFF = useIsAfterpayFinanceFeeEligible()

  return (
    <>
      <div className={styles.payInMoreTaglineHeading}>
        <Heading size={textSize}>
          {t(hasZeroAprPromotion || isAFF ? 'consumerLending:payInMoreWithoutInterestTagLine' : 'consumerLending:payInMoreTagline')}
        </Heading>
      </div>
    </>
  )
}
